import React, { FC } from 'react';
import styles from './indexBadge.module.scss';

interface IndexBadgeProps {
  index: number;
}

export const IndexBadge: FC<IndexBadgeProps> = ({ index }) => {
  return (
    <div className={styles.ingredientBadgeWrapper}>
      <div className={styles.ingredientBadge}>{index + 1}</div>
    </div>
  );
};
